<div id="app-wrapper" class="h-screen flex flex-col">
  <!-- Topbar -->
  <header id="main-header" class="bhub-shell-header">
    <div class="bhub-shell-header__left">
      <a
        [routerLink]="'/dashboard'"
        class="flex items-center gap-3 no-underline rounded focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
      >
        <p-avatar styleClass="bg-primary text-white" shape="circle" size="normal">
          <i class="pi pi-microchip-ai"></i>
        </p-avatar>
        <span class="text-xl font-semibold">BrightAI Demo</span>
      </a>
    </div>
    <div class="bhub-shell-header__center">
      <core-search-omni-search></core-search-omni-search>
    </div>
    <div class="bhub-shell-header__right">
      <span class="bhub-shell-header__user">{{ userDisplayName() }}</span>
      <bhub-notifications />
      <bhub-demo-step-controls />
    </div>
  </header>
  <div class="flex h-full">
    <!-- Sidebar -->
    <aside
      id="main-sidebar"
      [class.sidebar--collapsed]="isSidebarCollapsed()"
    >
      <nav class="flex-1 px-2 py-4 overflow-y-auto">
        @if (displayMenu()) {
          <div>
            <bhub-menu></bhub-menu>
          </div>
        }
      </nav>
      <div class="px-4 py-3 border-t border-surface-200">
        <ul class="space-y-1">
          <li>
            <button
              type="button"
              (click)="signOut()"
              class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-white text-left
               hover:bg-primary-700 focus-visible:ring-2 focus-visible:ring-white"
              pRipple
            >
              <i class="pi pi-sign-out text-base"></i>
              <span>Sign Out</span>
            </button>
          </li>
          @if (displayMenu()) {
            <li>
              <button
                type="button"
                (click)="toggleSidebarCollapse()"
                class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-white text-left
                 hover:bg-primary-700 focus-visible:ring-2 focus-visible:ring-white"
                pRipple
              >
                <i
                  class="pi"
                  [ngClass]="{
                    'pi-angle-double-left': !isSidebarCollapsed(),
                    'pi-angle-double-right': isSidebarCollapsed()
                  }"
                ></i>
                <span>Collapse</span>
              </button>
            </li>
          }
        </ul>
      </div>
    </aside>

    <!-- Main content area (id is skip-link target from app root; keep in sync with skip-link href) -->
    <div id="main-content" class="flex-1 flex flex-col">
      <!-- Page content -->
      <main
        class="bg-surface-100 dark:bg-surface-800 overflow-hidden"
        [style.max-height]="'calc(100vh - 3.5rem)'"
      >
        <div
          [@fadeIn]
          class="text-gray-500 dark:text-gray-300"
        >
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>
</div>
